import React ,{useState} from 'react';
import Video from '../../assests/videos/video.mp4'
import {Button} from '../ButtonElements';
import {HeroContainer,HeroBg , VideoBg , HeroContent, 
HeroH1 , HeroP , HeroBtnWrapper , ArrowForward , ArrowRight} from './heroElements';

const HeroSection = () => {

    const [hover , setHover] = useState(false);

    const onHover = () =>{
        setHover(!hover);
    }

  return (
    <HeroContainer id='home'>
        <HeroBg>
            <VideoBg autoPlay loop muted src={Video} type='video/mp4'/>
            </HeroBg>
            <HeroContent>
                <HeroH1>Wellcome to my Website</HeroH1>
                <HeroP> Elad Barzilay a full stack developer </HeroP>
                <HeroBtnWrapper>
                    <Button to="about" onMouseEnter={onHover} onMouseLeave={onHover}
                    primary="true"
                    dark="true"
                    smooth={true}
                    duration={500}>
                        To see more {hover?<ArrowForward/>:<ArrowRight/>}
                    </Button>
                </HeroBtnWrapper>
            </HeroContent>
    </HeroContainer>
  )
}

export default HeroSection